export interface EditAdminOperatorState {
    editAdminOperatorData: any;
    loading: boolean;
    error: null | string;
}


export enum EditAdminOperatorActionTypes {
    FETCH_EDIT_ADMIN_OPERATOR_DATA = "FETCH_EDIT_ADMIN_OPERATOR_DATA",
    FETCH_EDIT_ADMIN_OPERATOR_DATA_SUCCESS = "FETCH_EDIT_ADMIN_OPERATOR_DATA_SUCCESS",
    FETCH_EDIT_ADMIN_OPERATOR_DATA_ERROR = "FETCH_EDIT_ADMIN_OPERATOR_DATA_ERROR",
}

export type EditAdminOperatorAction =
    | { type: EditAdminOperatorActionTypes.FETCH_EDIT_ADMIN_OPERATOR_DATA }
    | { type: EditAdminOperatorActionTypes.FETCH_EDIT_ADMIN_OPERATOR_DATA_SUCCESS; payload: any[] }
    | { type: EditAdminOperatorActionTypes.FETCH_EDIT_ADMIN_OPERATOR_DATA_ERROR; payload: string };

